import Vue from 'vue'
import HeaderModals from 'app/components/modals/header-modals.vue'
import store from 'app/store'
import { router } from 'app/store'
import { bp } from 'app/constants'
import Modernizr from 'app/.modernizrrc'

export class Header {
  constructor() {
    this.BODY = document.body || {}
    this.header = document.getElementById('header') || {}
    this.hamburger = document.getElementById('hamburger')
    this.searchInput = document.getElementById('searchInput')
    // this.dropDownButtons = [...document.querySelectorAll('.dropdown-button')]
    this.dropDownButtons = document.querySelectorAll('.dropdown-button')
    this.blurButtons = document.querySelectorAll('*[data-blur-hovers]')
    this.headerDistanceFromTop = this.header ? this.header.offsetTop : 0
    this.headerHeight = this.header ? this.header.offsetHeight : 0
    this.isHeaderFixed = false
    this.headerMediaQuery = window.matchMedia(`(max-width: ${bp.headerTablet}px)`)
    this.HeaderModalsView = new Vue({
      components: { HeaderModals },
      store,
      router,
      beforeMount() {
        const { commit } = this.$store
        const { user } = Laravel
        commit('setUser', { ...user })
        // old set user, commented out in favor of taking all that is in user object
        //   {
        //   id: user.id,
        //   avatar: user.avatar,
        //   displayName: user.displayName,
        //   email: user.email,
        //   firstName: user.firstName,
        //   isLoggedIn: user.isLoggedIn,
        //   lastName: user.lastName,
        //   onEmailList: user.onEmailList,
        //   username: user.username,
        //   notificationCount: user.notificationCount,
        //   startMonday: user.startMonday,
        // })
      },
      render(h) {
        return <HeaderModals />
      },
    })
  }

  // On tap ensure all other dropdown menus are removed

  removeHovers(el) {
    this.dropDownButtons.forEach(function (button) {
      if (button.parentElement !== el.parentElement) {
        button.parentElement.classList.remove('hover')
      }
    })
  }

  // Display dropdown on tap or click

  dropdownAction(el) {
    this.removeHovers(el)
    if (!el.parentElement.classList.contains('hover')) {
      // Hover not already active: display  it
      el.parentElement.classList.add('hover')
      if (el.parentElement.dataset.focus === 'search') {
        setTimeout(() => this.searchInput.focus(), 5)
      }
    } else {
      // Hover is already active: remove it and goto anchor link on 'second' tap where applicable (for pointerevents it's sufficient to use remoove preventDefault, for touchvents use window.location)
      if (Modernizr.pointerevents) {
        el.removeEventListener('click', this.preventDefault)
      } else if (Modernizr.touchevents) {
        if ('menulink' in el.dataset) {
          window.location.href = el.href
        }
      }
      if (el.parentElement.dataset.focus === 'search') {
        this.searchInput.blur()
      }
      el.parentElement.classList.remove('hover')
    }
  }

  // Remove dropdown on mouseout of clickable dropdown (search box)

  mouseOut(e) {
    if (!Modernizr.touchevents || Modernizr.pointerevents) {
      const el = e.currentTarget
      if (el.dataset.focus === 'search') {
        this.searchInput.blur()
      }
      el.classList.remove('hover')
      el.removeEventListener('mouseleave', this.mouseOut)
    }
  }

  // Prevent default on top level menulinks, for touch input they should only work on second tap

  preventDefault(e) {
    e.preventDefault()
  }

  // Implement collapsed site header on scroll

  handleSiteHeader() {
    if (window.pageYOffset - this.headerHeight >= this.headerDistanceFromTop) {
      if (this.isHeaderFixed) {
        return
      }
      this.BODY.classList.add('fixed-header')
      this.isHeaderFixed = true
    } else {
      if (!this.isHeaderFixed) {
        return
      }
      this.BODY.classList.remove('fixed-header')
      this.isHeaderFixed = false
    }
  }

  init() {
    // Mount Error Modals right after header element
    // @TD These should eventually be removed from the header into the modal refactor

    const errorModalElement = document.createElement('div')
    this.header.parentNode.insertBefore(errorModalElement, this.header)
    this.HeaderModalsView.$mount(errorModalElement)

    // Apply event to each dropdown button

    this.dropDownButtons.forEach((el) => {
      // Bind keyboard event to enter key
      el.addEventListener('keypress', (e) => {
        if (e.keyCode == 13) {
          this.dropdownAction(el)
        }
      })

      if (el.dataset.event === 'hover') {
        if (Modernizr.pointerevents) {
          // Hoverable element / pointerevents supported: trigger dropdown action, bind preventDefault to remove later
          el.addEventListener('pointerdown', (e) => {
            e.preventDefault()
            this.dropdownAction(el)
          })
        } else {
          // Hoverable element, touchevents supported: trigger dropdown action, preventDefault on click will use window.location to navigate
          el.addEventListener('click', (e) => {
            e.preventDefault()
            this.dropdownAction(el)
          })
        }
      }

      // TODO: remove this code after cross browser testing
      // Original events that did not work on amazon fire tv
      // if (Modernizr.pointerevents && el.dataset.event === 'hover') {
      //   // Hoverable element / pointerevents supported: trigger dropdown action, bind preventDefault to remove later
      //   el.addEventListener('pointerdown', e => {
      //     if (e.pointerType === 'touch') {
      //       el.addEventListener('click', this.preventDefault)
      //       this.dropdownAction(el)
      //     }
      //   })
      // } else if (Modernizr.touchevents && el.dataset.event === 'hover') {
      //   // Hoverable element, touchevents supported: trigger dropdown action, preventDefault on click will use window.location to navigate
      //   el.addEventListener('click', e => {
      //     e.preventDefault()
      //     this.dropdownAction(el)
      //   })
      // }
      else if (el.dataset.event === 'click') {
        // Dropdown element works on click as opposed to hover (specifically search)
        // Bind mouseleave to dismiss for users with mouse input
        this.mouseOut = this.mouseOut.bind(this)
        if (Modernizr.pointerevents) {
          el.addEventListener('pointerdown', (e) => {
            e.preventDefault()
            this.dropdownAction(el)
            if (e.pointerType !== 'touch') {
              el.parentElement.addEventListener('mouseleave', this.mouseOut)
            }
          })
        } else {
          el.addEventListener('click', (e) => {
            e.preventDefault()
            this.dropdownAction(el)
            el.parentElement.addEventListener('mouseleave', this.mouseOut)
          })
        }
      }
    })

    // Remove hovers when specific buttons gain focus

    this.blurButtons.forEach((el) => {
      el.addEventListener('focus', (e) => {
        this.removeHovers(el)
      })
    })

    // Toggle Hamburger menu
    if (this.hamburger) {
      this.hamburger.addEventListener('click', () => {
        this.BODY.classList.toggle('mobile-open')
        this.hamburger.classList.toggle('-exed')

        // replace inner html with close icon
        if (this.hamburger.classList.contains('-exed')) {
          this.hamburger.innerHTML = '<i class="material-icons">close</i>'
        } else {
          this.hamburger.innerHTML = '<i class="material-icons">menu</i>'
        }
      })
    }

    // Dismiss Hamburger menu if user switches between tablet/mobile view and desktop view
    this.headerMediaQuery.addListener(() => {
      this.BODY.classList.remove('mobile-open')
      this.hamburger.classList.remove('-exed')
    })

    // On scroll determine when to display fixed collapsed nav
    // @TD Suggestion: Implement with Intersection observer and fallback to scroll for browsers that don't support

    this.handleSiteHeader = this.handleSiteHeader.bind(this)
    window.addEventListener('scroll', this.handleSiteHeader)
  }
}
